var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPressureActuator({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10,
    y1: 8,
    x2: 11.2,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 12.2,
    y1: 8,
    x2: 13.4,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14.3,
    y1: 8,
    x2: 15.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 3.3,
    className: "st0",
    width: 9.4,
    height: 9.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.6,10.3V5.6h1.8c0.3,0,0.6,0,0.7,0c0.2,0,0.4,0.1,0.6,0.2C6.9,6,7,6.1,7.1,6.3S7.2,6.7,7.2,7 c0,0.4-0.1,0.7-0.4,1S6.1,8.4,5.5,8.4H4.2v1.9H3.6z M4.2,7.8h1.2c0.4,0,0.7-0.1,0.9-0.2C6.5,7.5,6.6,7.3,6.6,7 c0-0.2-0.1-0.4-0.2-0.5C6.3,6.3,6.2,6.2,6,6.2c-0.1,0-0.3,0-0.6,0H4.2V7.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressureActuator);
export default __webpack_public_path__ + "static/media/PressureActuator.4beae881f34062bd9657bc988cfd3d1a.svg";
export { ForwardRef as ReactComponent };